import { render, staticRenderFns } from "./InvestorFAQTable.vue?vue&type=template&id=1947c684&scoped=true&"
import script from "./InvestorFAQTable.vue?vue&type=script&lang=js&"
export * from "./InvestorFAQTable.vue?vue&type=script&lang=js&"
import style0 from "./InvestorFAQTable.vue?vue&type=style&index=0&id=1947c684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947c684",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
